export const Connexion_Onchange_TYPE = 'SET_ConnexionOnchange';
export const App_Set_Login_TYPE = 'SET_AppSetLogin';
export const App_Set_Logout_TYPE = 'SET_AppSetLogout';
export const PersistActions_TYPE = 'SET_PersistActions';
export const Connexion_Constraint_Data_Onchange_TYPE = 'SET_ConnexionConstraintDataOnchange';